module.exports = __webpack_public_path__ + "img/articles_g.ea8edc58.svg";